import * as currentConfig from './config-current'

const {
  sraDomain,
  domain,
  sraPortalDomain,
  sraSfdcDomain,
  ncPortalDomain,
  azureClientId,
  azureTenantId,
  apiKey,
  stage,
  featureFlags,
} = currentConfig

const emailAzureClientId = currentConfig.emailAzureClientId
const emailAzureTenantId = currentConfig.emailAzureTenantId

export const Stage = stage
export const FeatureFlags = featureFlags
export const ApiGateway =  {
  apiKey,
  sraDomain,
  domain,
  email: `${domain}/email`,
  formulaNutrition: `${domain}/formula-nutritions`,
  dispensingHardwareType: `${domain}/dispensing-hardware-types`,
  documentGeneration: `${domain}/document-generation`,
  employee: `${domain}/employees`,
  pdfService: `${domain}/pdf-service`,
  labelDeclarationSheets: `${domain}/lds-service`,
  profile: `${sraDomain}/profile`,
  user: `${sraDomain}/users`,
  genesis: `${domain}/genesis`,
  auth: ''
}

export const SraPortalDomain = sraPortalDomain
export const SraSfdcDomain = sraSfdcDomain
export const NcPortalDomain = ncPortalDomain

export const AzureAdClient = {
  info: {
    clientId: `${azureClientId}`,
    tenantId: `${azureTenantId}`
  },
  auth: {
    clientId: `${azureClientId}`,
    authority: `https://login.microsoftonline.com/${azureTenantId}`
  }
}

export const AzureAdEmailClient = {
  info: {
    clientId: `${emailAzureClientId || azureClientId}`,
    tenantId: `${emailAzureTenantId || azureTenantId}`,
  },
  auth: {
    clientId: `${emailAzureClientId || azureClientId}`,
    authority: `https://login.microsoftonline.com/${emailAzureTenantId || azureTenantId}`,
  },
}
